import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=007e0d57&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007e0d57')) {
      api.createRecord('007e0d57', component.options)
    } else {
      api.reload('007e0d57', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=007e0d57&", function () {
      api.rerender('007e0d57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/content-manage/comment/comment.vue"
export default component.exports